// Reusable JSON-LD builders for Aranon pages.
const ORG_ID = "https://aranon.dev/#organization";
const SITE = "https://aranon.dev";

export const orgRef = { "@id": ORG_ID };

export const breadcrumb = (
  items: { name: string; path: string }[]
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});

export const service = (args: {
  name: string;
  description: string;
  path: string;
  serviceType: string;
  areaServed?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: args.name,
  description: args.description,
  url: `${SITE}${args.path}`,
  serviceType: args.serviceType,
  provider: orgRef,
  areaServed: args.areaServed || "Worldwide",
});

export const itemList = (args: {
  name: string;
  items: { name: string; path: string; description?: string }[];
}) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: args.name,
  itemListElement: args.items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: `${SITE}${it.path}`,
    name: it.name,
    ...(it.description ? { description: it.description } : {}),
  })),
});

export const aboutPage = (args: {
  name: string;
  description: string;
  path: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: args.name,
  description: args.description,
  url: `${SITE}${args.path}`,
  about: orgRef,
});

export const contactPage = (args: {
  name: string;
  description: string;
  path: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: args.name,
  description: args.description,
  url: `${SITE}${args.path}`,
  about: orgRef,
});

export const faqPage = (faqs: { q: string; a: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
